// @ts-nocheck
import forIn from 'lodash/forIn';
import isObject from 'lodash/isObject';
import omit from 'lodash/omit';
import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';
import moment from 'moment';
import dayjs from 'dayjs';
var toFloat = function toFloat(v) {
  return parseFloat(v.toString().replace(/\,/g, '.'));
};
var defaultOptions = {
  skipUndefinedKeys: true
};
var castValue = function castValue(type, value) {
  if (isNil(value)) return undefined;
  switch (type.toLowerCase()) {
    case 'float':
      return toFloat(value);
    case 'integer':
      return parseInt(value, 10);
    case 'string':
      return typeof value === 'string' ? value : value.toString();
    case 'date':
      var mDate = value;
      if (!dayjs.isDayjs(mDate) && !moment.isMoment(mDate)) mDate = dayjs(mDate);
      if (!mDate.isValid()) return null;
      return mDate.format('YYYY-MM-DD');
    case 'datetime':
      var mDateTime = value;
      if (!dayjs.isDayjs(mDateTime) && !moment.isMoment(mDateTime)) mDate = dayjs(mDateTime);
      if (!mDateTime.isValid()) return null;
      return mDateTime.format();
    case 'password':
    case 'files':
      if (value) return value.filter(function (f) {
        return f instanceof File;
      });
      return [];
    case 'file':
      if (value) return value;
      return;
    default:
      return value;
  }
};
var reverseCastValue = function reverseCastValue(type, value) {
  var _value$location, _value$location2, _value$location3, _value$location4, _value$location5;
  switch (type.toLowerCase()) {
    case 'files':
      return value.filter(function (f) {
        return f instanceof File;
      });
    case 'file':
      return value;
    case 'location':
      return {
        location: {
          formattedAddress: (value === null || value === void 0 ? void 0 : (_value$location = value.location) === null || _value$location === void 0 ? void 0 : _value$location.formattedAddress) || (value === null || value === void 0 ? void 0 : value.formattedAddress),
          lat: value !== null && value !== void 0 && (_value$location2 = value.location) !== null && _value$location2 !== void 0 && _value$location2.lat || value !== null && value !== void 0 && value.lat ? toFloat(((_value$location3 = value.location) === null || _value$location3 === void 0 ? void 0 : _value$location3.lat) || (value === null || value === void 0 ? void 0 : value.lat)) : undefined,
          lng: value !== null && value !== void 0 && (_value$location4 = value.location) !== null && _value$location4 !== void 0 && _value$location4.lng || value !== null && value !== void 0 && value.lat ? toFloat(((_value$location5 = value.location) === null || _value$location5 === void 0 ? void 0 : _value$location5.lng) || (value === null || value === void 0 ? void 0 : value.lng)) : undefined
        },
        proximity: value.proximity ? parseInt(value.proximity, 10) : undefined
      };
    case 'boolean':
      if (!value) return null;
      return value === "true" || value === "1" || value;
    case 'float':
      return toFloat(value);
    case 'integer':
      return parseInt(value, 10);
    case 'string':
      return typeof value === 'string' ? value : value.toString();
    case 'datetime':
    case 'date':
      if (dayjs.isDayjs(value)) return value;
      return moment.isMoment(value) ? value : dayjs(value);
    default:
      return value;
  }
};
export var reverseCastFromDefinition = function reverseCastFromDefinition(model, attributes) {
  var castedAttributes = {};
  forIn(model, function (value, key) {
    if (Array.isArray(value) && !isNil(attributes[key])) {
      castedAttributes[key] = attributes[key].map(function (v) {
        return reverseCastValue(value[0], v);
      });
    } else if (!isNil(attributes[key])) {
      castedAttributes[key] = reverseCastValue(value, attributes[key]);
    }
  });
  return castedAttributes;
};
function castAttributesFromModel(model, attributes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  var formattedModel = {};
  forIn(model, function (value, key) {
    if (isObject(value)) {
      if (value.type === 'Places') {
        var _value$options, _attributes$key, _value$options2, _attributes$key2, _value$options3, _attributes$key3, _value$options4, _attributes$key4, _value$options5, _value$options6, _attributes$key5, _value$options7, _value$options8, _attributes$key6, _value$options9, _attributes$key7, _attributes$key7$admi, _attributes$key7$admi2, _value$options10, _value$options11;
        formattedModel[((_value$options = value.options) === null || _value$options === void 0 ? void 0 : _value$options.formattedAddress) || key] = (_attributes$key = attributes[key]) === null || _attributes$key === void 0 ? void 0 : _attributes$key.formattedAddress;
        formattedModel[((_value$options2 = value.options) === null || _value$options2 === void 0 ? void 0 : _value$options2.city) || 'city'] = (_attributes$key2 = attributes[key]) === null || _attributes$key2 === void 0 ? void 0 : _attributes$key2.city;
        formattedModel[((_value$options3 = value.options) === null || _value$options3 === void 0 ? void 0 : _value$options3.lat) || 'lat'] = (_attributes$key3 = attributes[key]) === null || _attributes$key3 === void 0 ? void 0 : _attributes$key3.lat;
        formattedModel[((_value$options4 = value.options) === null || _value$options4 === void 0 ? void 0 : _value$options4.lng) || 'lng'] = (_attributes$key4 = attributes[key]) === null || _attributes$key4 === void 0 ? void 0 : _attributes$key4.lng;
        if ((_value$options5 = value.options) !== null && _value$options5 !== void 0 && _value$options5.countryIso) formattedModel[((_value$options6 = value.options) === null || _value$options6 === void 0 ? void 0 : _value$options6.countryIso) || 'countryIso'] = (_attributes$key5 = attributes[key]) === null || _attributes$key5 === void 0 ? void 0 : _attributes$key5.countryIso;
        if ((_value$options7 = value.options) !== null && _value$options7 !== void 0 && _value$options7.country) formattedModel[((_value$options8 = value.options) === null || _value$options8 === void 0 ? void 0 : _value$options8.country) || 'country'] = (_attributes$key6 = attributes[key]) === null || _attributes$key6 === void 0 ? void 0 : _attributes$key6.country;
        if ((_value$options9 = value.options) !== null && _value$options9 !== void 0 && _value$options9.administrativeLevelOne) formattedModel[value.options.administrativeLevelOne] = (_attributes$key7 = attributes[key]) === null || _attributes$key7 === void 0 ? void 0 : (_attributes$key7$admi = _attributes$key7.administrativeAreaLevels) === null || _attributes$key7$admi === void 0 ? void 0 : (_attributes$key7$admi2 = _attributes$key7$admi.find(function (a) {
          return a.types.includes('administrative_area_level_1');
        })) === null || _attributes$key7$admi2 === void 0 ? void 0 : _attributes$key7$admi2.long_name;
        if ((_value$options10 = value.options) !== null && _value$options10 !== void 0 && _value$options10.administrativeLevelTwo) {
          var _attributes$key8, _attributes$key8$admi, _attributes$key8$admi2;
          formattedModel[value.options.administrativeLevelTwo] = (_attributes$key8 = attributes[key]) === null || _attributes$key8 === void 0 ? void 0 : (_attributes$key8$admi = _attributes$key8.administrativeAreaLevels) === null || _attributes$key8$admi === void 0 ? void 0 : (_attributes$key8$admi2 = _attributes$key8$admi.find(function (a) {
            return a.types.includes('administrative_area_level_2');
          })) === null || _attributes$key8$admi2 === void 0 ? void 0 : _attributes$key8$admi2.long_name;
        }
        if ((_value$options11 = value.options) !== null && _value$options11 !== void 0 && _value$options11.zipCode) {
          var _attributes$key9;
          formattedModel[value.options.zipCode] = (_attributes$key9 = attributes[key]) === null || _attributes$key9 === void 0 ? void 0 : _attributes$key9.zipCode;
        }
      } else if (isArray(value) && !isNil(attributes[key])) {
        formattedModel[key] = attributes[key].map(function (v) {
          return castValue(value[0], v);
        });
      } else {
        if (!isNil(attributes[key])) {
          var attributeValue = attributes[key];
          if (attributeValue) formattedModel["".concat(key, "Attributes")] = isArray(attributeValue) ? attributeValue.map(function (v) {
            return castAttributesFromModel(value, v);
          }) : castAttributesFromModel(value, attributeValue);
        }
      }
    } else if (!isNil(attributes[key])) {
      switch (value.toLowerCase()) {
        case 'attachment':
          if (attributes[key].id) formattedModel["".concat(key, "Id")] = attributes[key].id;
          break;
        case 'files':
          if (attributes[key]) formattedModel[key] = castValue('Files', attributes[key]);
          break;
        case 'file':
          if (attributes[key] && attributes[key] instanceof File) formattedModel[key] = castValue('File', attributes[key]);
          break;
        case 'password':
          if (attributes[key]) formattedModel[key] = castValue('String', attributes[key]);
          break;
        case 'nested':
          if (attributes[key]) formattedModel["".concat(key, "Attributes")] = isArray(attributes[key]) ? attributes[key].map(function (v) {
            return omit(v, ['__typename']);
          }) : omit(attributes[key], ['__typename']);
          break;
        default:
          formattedModel[key] = castValue(value.toLowerCase(), attributes[key]);
          break;
      }
    } else if (value !== 'password' && value !== 'nested' && value !== 'id' && value !== "Attachment") {
      if (!options.skipUndefinedKeys || attributes.hasOwnProperty(key)) formattedModel[key] = null;
    }
  });
  return formattedModel;
}
export default castAttributesFromModel;